import { getLogger } from "@expert/logging";

import { getGamificationApiClient } from "@/sales-tools/api/api";

import type { ScheduleResponse } from "./types";

const logger = getLogger({ module: "getSchedule" });

function isScheduleResponse(data: unknown): data is ScheduleResponse {
    if (typeof data !== "object" || data === null) return false;
    const obj = data as Record<string, unknown>;
    if (!("date" in obj) || !Array.isArray(obj.blocks)) return false;
    // Every block must carry string start/end times — otherwise toBusinessTime(undefined) would
    // silently map to "now" and place the event at the wrong spot instead of failing the guard.
    return obj.blocks.every((block) => {
        if (block == null || typeof block !== "object") return false;
        const b = block as Record<string, unknown>;
        return typeof b.startTime === "string" && typeof b.endTime === "string";
    });
}

/** Fetch the expert's schedule for a business day (YYYY-MM-DD). Returns null on a shape mismatch. */
export const getSchedule = async (date: string): Promise<ScheduleResponse | null> => {
    const resp: unknown = await getGamificationApiClient().get("v1/schedule", { searchParams: { date } }).json();

    if (!isScheduleResponse(resp)) {
        logger.warn(
            { date, responseKeys: resp ? Object.keys(resp as object) : null },
            "Off-call hub: schedule API response did not match expected shape",
        );
        return null;
    }

    return resp;
};
